import React from 'react';

type PageHeadingProps = {
  /** Page title. Accepts a node so callers can pass a `<T>` string or
   *  dynamic content (e.g. the time-of-day greeting on the home page). */
  title: React.ReactNode;
  /** Optional one-line description shown under the title. */
  subtitle?: React.ReactNode;
};

/**
 * Standard page heading: a large title with an optional muted subtitle,
 * matching the home-page greeting. Must render inside a `wh-ui` scope so it
 * picks up the Geist font and WasteHero text tokens — shadcn pages already
 * provide it; on legacy antd pages wrap the heading in `<div className="wh-ui">`.
 */
export function PageHeading({ title, subtitle }: PageHeadingProps) {
  return (
    <header className="flex flex-col gap-2">
      <h1 className="text-balance text-2xl font-semibold leading-tight tracking-tight text-[var(--text-primary)]">
        {title}
      </h1>
      {subtitle && (
        <p className="text-pretty text-xl leading-normal text-[var(--text-secondary)]">
          {subtitle}
        </p>
      )}
    </header>
  );
}

export default PageHeading;
